import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@careflux/primitives';
import type { BucketSelectProps } from './components.types';
import type { TimelineBucket } from './types';

export const BucketSelect = ({ value, onChange }: BucketSelectProps) => (
  <Select value={value} onValueChange={(next) => onChange(next as TimelineBucket)}>
    <SelectTrigger className="w-[120px]" aria-label="Tímaeining">
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="day">Dagar</SelectItem>
      <SelectItem value="week">Vikur</SelectItem>
    </SelectContent>
  </Select>
);
